import {
    LinkButton,
    useAnalytics,
    useAnalyticsAttributes
} from "../../components";
import { UiButtonModel } from "../../models";
import { MapModelToProps } from "../../utils";

export type UiButtonProps = MapModelToProps<UiButtonModel>;

const UiButton = ({ model }: UiButtonProps) => {
    const { sendTrackEvent } = useAnalytics();
    const { entryTitle, text, ariaLabel, url, buttonTheme } = model.content;
    const theme = buttonTheme ? { ...buttonTheme.content } : {};
    // Remove `title` (entryTitle) from props since it is a valid attribute
    const { title, ...buttonThemeProps } = theme;
    const analyticsAttributes = useAnalyticsAttributes();
    const props = {
        onClick: () =>
            sendTrackEvent("clickedUiButton", {
                eventContainer: "content",
                ...analyticsAttributes,
                event: "clicked",
                eventComponent: "button",
                label: text,
                labelEnglish: entryTitle,
                uuid: model.id,
                href: url,
                theme: theme
            }),
        url,
        ...buttonThemeProps
    };
    return (
        <LinkButton {...props} aria-label={ariaLabel} data-uuid={model.id}>
            {text}
        </LinkButton>
    );
};

export default UiButton;
